export default function RoundImage({ imageUrl }) {
  return (
    <figure className="image">
      <img
        className="is-square"
        style={{
          aspectRatio: 1,
          objectFit: "cover",
          height: "300px",
          borderRadius: "6%",
        }}
        loading="lazy"
        src={imageUrl}
        alt="failed to load"
        objectfit="cover"
      />
    </figure>
  );
}
